<template>
  <div class="py-4">
    <b-container>
      <p>
        O CPGeo possui basicamente duas formas de contrato. O contrato por
        projeto e o contrato por demanda.
      </p>
    </b-container>
    <b-container>
      <b-row cols="1" cols-md="2">
        <b-col>
          <div class="card bg-light mb-3">
            <div class="card-header">
              Contrato por Projeto
            </div>
            <div class="card-body">
              <p class="card-text">
                Na modalidade Contrato por Projeto, o cliente identifica quais
                linhas 2D ou sísmica 3D necessita processar ou reprocessar. O
                CPGeo realiza o serviço e após o recebimento dos dados e
                aprovação do empresa contratante, o CPGeo emite a Nota Fiscal,
                cujo pagamento será realizado 30 dias após a emissão.
              </p>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="card bg-light mb-3">
            <div class="card-header">
              Contrato por demanda
            </div>
            <div class="card-body">
              <p class="card-text">
                Na modalidade Contrato por Demanda, o CPGeo e a Empresa
                Contratante assinam um contrato de longo prazo e a medida que o
                Contratante necessita processar ou reprocessar os dados
                sísmicos, o CPGeo realiza o serviço e mensalmente é realizada a
                medição dos serviços e emitida a Nota Fiscal, após o recebimento
                dos dados e aprovação pela Contratante. O pagamento é realizado
                30 dias após a emissão da Nota Fiscal.
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
      <hr />
      <h3 class="text-center pb-2">Conteúdo local</h3>
      <p>
        O CPGeo se compromete a realizar o projeto com o mínimo de 90% de
        conteúdo local, cujo certificado será emitido por empresa credenciada
        junto a ANP – Agencia Nacional do Petróleo, Gás Natural e
        Biocombustíveis.
      </p>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Contratacao",
};
</script>
